var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg067Private(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10H20.75L19.38 5.17C19.0103 3.88604 17.8361 3.00129 16.5 3H7.5C6.16388 3.00129 4.98966 3.88604 4.62 5.17L3.25 10H3C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12H21C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10ZM5.33 10L6.55 5.72C6.67339 5.29687 7.05926 5.00441 7.5 5H16.5C16.9407 5.00441 17.3266 5.29687 17.45 5.72L18.67 10H5.33ZM13.14 16C13.5948 14.2386 15.1808 13.0059 17 13C19.0803 12.9933 20.8186 14.5823 20.9981 16.6548C21.1776 18.7274 19.7384 20.5916 17.6879 20.9426C15.6374 21.2936 13.6601 20.0143 13.14 18H10.86C10.3564 19.9503 8.48121 21.2219 6.483 20.9681C4.48479 20.7143 2.98702 19.0143 2.98702 17C2.98702 14.9857 4.48479 13.2857 6.483 13.0319C8.48121 12.7781 10.3564 14.0497 10.86 16H13.14ZM5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17ZM17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg067Private);
export default __webpack_public_path__ + "static/media/067-private.3e2199e9afb7600471fc8fb22a410604.svg";
export { ForwardRef as ReactComponent };